<template>
  <div>
    <main-navigation></main-navigation>

    <div class="container py-4">

      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 class="fw-bold mb-1">Units in {{ houseName }}</h2>
          <small class="text-muted">
            Total: {{ summary.total }} |
            Occupied: {{ summary.occupied }} |
            Vacant: {{ summary.vacant }}
          </small>
        </div>

        <router-link
          :to="`/house/${this.houseId}/water-readings`"
          
          class="btn btn-primary btn-sm"
        >
          <i class="bi bi-plus-lg me-1"></i>upload water bill
        </router-link>

        
        <router-link
          :to="`/house/${this.houseId}/electricity-readings`"
          
          class="btn btn-primary btn-sm"
        >
          <i class="bi bi-plus-lg me-1"></i>upload Electricity bill
        </router-link>

        
        <router-link
          :to="`/add-units`"
          
          class="btn btn-primary btn-sm"
        >
          <i class="bi bi-plus-lg me-1"></i>Add Unit
        </router-link>
      </div>

      <!-- Loading -->
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-primary"></div>
        <p class="text-muted mt-2">Loading units...</p>
      </div>

      <!-- Error -->
      <div v-if="error" class="alert alert-danger">
        <i class="bi bi-exclamation-triangle-fill me-2"></i>{{ error }}
      </div>

      <!-- Units Table -->
      <div v-if="!loading && units.length" class="dash-card">
        <div class="dash-table-wrap">
          <table class="dash-table">
            <thead>
              <tr>
                <th>Unit</th>
                <th>Rent</th>
                <th>Deposit</th>
                <th>Status</th>
                <th>Tenant</th>
                <th>phone</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="unit in units" :key="unit.id">
                <!-- {{ unit }} -->
                <td class="fw-semibold">{{ unit.unit_number }}</td>
                <td>{{ formatCurrency(unit.rent_amount) }}</td>
                <td>{{ formatCurrency(unit.deposit_amount) }}</td>

                <!-- Status -->
                <td>
                  <span
                    class="dash-badge"
                    :class="unit.status === 'occupied' ? 'dash-badge--success' : 'dash-badge--warning'"
                  >
                    {{ unit.status }}
                  </span>
                </td>

                <!-- Tenant -->
               <td>
  {{ unit.Tenant ? unit.Tenant.tenant_name : "-" }}
</td>
          <td>
  {{ unit.Tenant ? unit.Tenant.tenant_phone : "-" }}
</td>


                <!-- Action -->
                <td>
                  <router-link
                    v-if="unit.status === 'vacant'"
                    :to="`/assign/tenant/${unit.id}`"
                    class="btn btn-sm btn-outline-primary"
                  >
                    Assign Tenant
                  </router-link>

                  <!-- <router-link
                    v-else
                    :to="`/vacate/tenant/${unit.id}`"
                    class="btn btn-sm btn-outline-danger"
                  >
                    Vacate Tenant
                  </router-link> -->
                  <button
  v-else
  @click="vacateTenant(unit.id)"
  class="btn btn-sm btn-outline-danger"
>
  Vacate Tenant
</button>

                  
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Empty -->
      <div
        v-if="!loading && !units.length && !error"
        class="text-center py-5 text-muted"
      >
        <i class="bi bi-house-door" style="font-size: 3rem;"></i>
        <p class="mt-3">No units found for this house.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { apiFetch } from "@/services/api.js";

export default {
  name: "HouseUnits",

  data() {
    return {
      houseId: this.$route.params.houseId,
      houseName: "House",
      units: [],
      summary: {
        total: 0,
        occupied: 0,
        vacant: 0
      },
      loading: true,
      error: ""
    };
  },

  mounted() {
    this.fetchUnits();
  },

  methods: {
    async fetchUnits() {
      this.loading = true;
      this.error = "";

      try {
        const res = await apiFetch(`/units/house/${this.houseId}`);
        const rawUnits = res.data || [];

        // ✅ NORMALIZE STATUS
        this.units = rawUnits.map(unit => {
          const isOccupied =
            unit.tenant_id ||
            unit.tenant_name;

          return {
            ...unit,
            status: isOccupied ? "occupied" : "vacant"
          };
        });

        // Set house name
        if (this.units.length && this.units[0].House) {
          this.houseName = this.units[0].House.name;
        }

        // Summary
        const occupied = this.units.filter(u => u.status === "occupied").length;

        this.summary = {
          total: this.units.length,
          occupied,
          vacant: this.units.length - occupied
        };

      } catch (err) {
        console.error("Units fetch error:", err);
        this.error = err.message || "Failed to load units";
      } finally {
        this.loading = false;
      }
    },

async vacateTenant(unitId) {
  const confirm = window.confirm('Are you sure you want to vacate this tenant?');
  if (!confirm) return;

  try {
    // Put the unit_id in the URL path, not in the body
    const res = await apiFetch(`/vacate/tenant/${unitId}`, {
      method: 'POST'
      // No body needed since unit_id is in the URL
    });

    if (res.message || res.success) {
      await this.fetchUnits();
      alert('Tenant vacated successfully');
    }
  } catch (err) {
    console.error("Vacate tenant error:", err);
    alert(err.message || "Failed to vacate tenant");
  }
},
formatCurrency(amount) {
      if (!amount) return "-";
      return new Intl.NumberFormat("en-KE", {
        style: "currency",
        currency: "KES"
      }).format(amount);
    }
  }
};
</script>

<style scoped>
.spinner-border {
  width: 3rem;
  height: 3rem;
}
</style>
